import React, { useEffect, useState, useMemo } from "react";
import { Box, Popover } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GetCategories } from "../utils/categoryAPI";

// כמו ב-ProductList
const getParentId = (c) => c?.parentCategoryId ?? c?.parentCategoryID ?? null;

export default function CategoryGrid({
  src,
  hotspots = [],
  ratio = 0.5,
  maxWidth = 1200,
}) {
  const nav = useNavigate();

  // כל הקטגוריות
  const [categories, setCategories] = useState([]);

  // החלונית
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentRootId, setCurrentRootId] = useState(null);

  useEffect(() => {
    GetCategories().then((data) => {
      const arr = Array.isArray(data) ? data : [];
      setCategories(arr);
      console.log("CATEGORIES FROM API:", arr);
    });
  }, []);

  const subCategories = useMemo(() => {
    if (!currentRootId) return [];
    return categories.filter((c) => {
      const parentId = getParentId(c);
      return parentId != null && parentId == currentRootId;
    });
  }, [categories, currentRootId]);

  useEffect(() => {
    console.log("currentRootId:", currentRootId);
    console.log("subCategories:", subCategories);
  }, [currentRootId, subCategories]);

  // כאן השינוי: מקבלים את כל ה-hotspot, לא categoryId
  const handleOpen = (event, hotspot) => {
    // מחפשים קטגוריה ראשית לפי השם שמופיע ב-label
    const rootCat = categories.find(
      (c) => c.nameCategor === hotspot.label
    );

    if (!rootCat) {
      console.warn("לא נמצאה קטגוריה עבור hotspot:", hotspot);
      return;
    }

    setCurrentRootId(rootCat.id);      // למשל 21 עבור "כלי כתיבה"
    setAnchorEl(event.currentTarget);

  };

  const handleClose = () => {
    setAnchorEl(null);
    setCurrentRootId(null);
  };

  const popoverOpen = Boolean(anchorEl);

  const handleGoToProducts = (subId) => {
    handleClose();
    nav(`/products/sub/${subId}`);
  };

  return (
  <Box
  sx={{
    position: "relative",
    width: "100%",
    maxWidth: {
      xs: "100%",
      md: maxWidth,
    },
    minWidth: 0,
    mx: "auto",
    overflow: "hidden",
    boxSizing: "border-box",
  }}
>
      {/* שומר יחס */}
      <Box
  sx={{
    position: "relative",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    pt: `${ratio * 100}%`,
    overflow: "hidden",
  }}
>
        {/* התמונה */}
        <Box
          component="img"
          src={src}
          alt=""
          draggable={false}
          sx={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
           objectFit: "contain",
objectPosition: "center",
backgroundColor: "#ffffff",
            display: "block",
            userSelect: "none",
          }}
        />

        {/* Hotspots */}
        {hotspots.map((h) => (
          <Box
            key={h.id}
            component="button"
            aria-label={h.label || h.id}
            onClick={(e) => handleOpen(e, h)} 

            sx={{
              position: "absolute",
              left: `${h.x}%`,
              top: `${h.y}%`,
              width: `${h.w}%`,
              height: `${h.h}%`,
              background: "transparent",
              border: "none",
              padding: 0,
              cursor: "pointer",
            }}
          />
        ))}
      </Box>

      {/* חלונית תתי קטגוריות */}
    <Popover
  open={popoverOpen}
  anchorEl={anchorEl}
  onClose={handleClose}
  disableScrollLock
  marginThreshold={8}
  anchorOrigin={{
    vertical: "bottom",
    horizontal: "right",
  }}
  transformOrigin={{
    vertical: "top",
    horizontal: "right",
  }}
  PaperProps={{
    sx: {
      width: {
        xs: "calc(100vw - 24px)",
        sm: 500,
        md: 600,
      },
      maxWidth: {
        xs: "calc(100vw - 24px)",
        sm: "calc(100vw - 48px)",
        md: 700,
      },
      minWidth: 0,
      maxHeight: {
        xs: "65vh",
        sm: "70vh",
      },
      overflowX: "hidden",
      overflowY: "auto",
      boxSizing: "border-box",
      p: {
        xs: 1.5,
        sm: 2,
      },
      borderRadius: 2,
      boxShadow: 6,
      direction: "rtl",
    },
  }}
>
  <Box
    sx={{
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,

      columnCount: {
        xs: 1,
        sm: 2,
        md: 3,
      },

      columnGap: {
        xs: 1,
        sm: 2,
      },

      px: {
        xs: 0.5,
        sm: 1,
      },

      py: 1,
      boxSizing: "border-box",
    }}
  >
    {subCategories.length ? (
      subCategories.map((sub) => (
        <Box
          key={sub.id}
          component="button"
          type="button"
          onClick={() =>
            handleGoToProducts(sub.id)
          }
          sx={{
            display: "block",
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            breakInside: "avoid",
           mb: 0.5,
minHeight: 44,
py: 1,
px: 1,

            border: 0,
            borderRadius: 1,
            backgroundColor: "transparent",
            cursor: "pointer",

            direction: "rtl",
            textAlign: "right",
            whiteSpace: "normal",
            overflowWrap: "anywhere",

            fontSize: {
              xs: 15,
              sm: 16,
            },

            fontWeight: 700,
            color: "#D81B60",

            "&:hover": {
              backgroundColor:
                "rgba(216, 27, 96, 0.06)",
              textDecoration: "underline",
            },

            "&:focus-visible": {
              outline: "3px solid #111",
              outlineOffset: "2px",
            },
          }}
        >
          {sub.nameCategor}
        </Box>
      ))
    ) : (
      <Box
        role="status"
        sx={{
          py: 1,
          fontSize: 15,
          color: "gray",
        }}
      >
        אין תתי קטגוריות לקטגוריה זו
      </Box>
    )}
  </Box>
</Popover>
    </Box>
  );
}
